const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  tags: state => state.menu.tags,
  roles: () => {
    const roles = localStorage.getItem('roles')
    return roles ? [roles] : []
  }
}
export default getters
